import React from 'react';
import css from './css.module.less';
import {
  Form,
  RadioGroup,
  RadioItem,
  OriginalPicker,
} from 'src/components/Antd';
import { Select } from 'src/components/Antd/Select';
import { get } from 'lodash';
import { OriNumberInput } from 'src/components/Antd/NumberInput/NumberInput';
import moment from 'moment';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Item = Form.Item;
const Option = Select.Option;
const RangePicker = OriginalPicker.RangePicker;

export enum EPolicy {
  ANY_TIME = 'ANY_TIME',
  LAST_SPECIFIC_DAYS = 'LAST_SPECIFIC_DAYS',
  IN_BETWEEN = 'IN_BETWEEN',
  ON_DATE = 'ON_DATE',
  AFTER_DATE = 'AFTER_DATE',
  BEFORE_DATE = 'BEFORE_DATE',
}

const CommonDate = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    noStyle,
    options,
    selectName,
    hasAnytime,
    daysName,
    policyName,
    // typeName,
    singleDayName,
    dayRangeName,
    triggerSelectValue,
    selectPlaceholder,
    disabled,
    // rules,
    // suffix,
  } = props;
  return (
    <React.Fragment>
      <Item name={selectName} noStyle={noStyle}>
        <Select
          disabled={disabled}
          size='large'
          //getPopupContainer={() => document.body}
          className={css.select}
          placeholder={selectPlaceholder}>
          {(options || []).map((i) => {
            const { value, label } = i || {};
            return (
              <Option value={value} key={value}>
                {label}
              </Option>
            );
          })}
        </Select>
      </Item>
      <Item
        noStyle
        shouldUpdate={(p, c) => {
          const cT = get(c, selectName);
          const pT = get(p, selectName);
          return cT !== pT;
        }}>
        {(f) => {
          const { getFieldValue } = f;
          const select = getFieldValue(selectName);
          if (triggerSelectValue.includes(select)) {
            return (
              <React.Fragment>
                <Item
                  name={policyName}
                  noStyle={noStyle}
                  rules={[
                    {
                      required: true,
                      message: getI18n(
                        'general.advancedFilters.commonDate.requirePolicy',
                      ),
                    },
                  ]}>
                  <RadioGroup
                    className={css.groupContainer}
                    disabled={disabled}>
                    {hasAnytime && (
                      <RadioItem className={css.item} value={EPolicy.ANY_TIME}>
                        {getI18n('general.advancedFilters.commonDate.anyTime')}
                      </RadioItem>
                    )}
                    <RadioItem
                      className={css.item}
                      value={EPolicy.LAST_SPECIFIC_DAYS}>
                      {getI18n(
                        'general.advancedFilters.commonDate.specificDay',
                      )}
                    </RadioItem>
                    <RadioItem className={css.item} value={EPolicy.IN_BETWEEN}>
                      {getI18n(
                        'general.advancedFilters.commonAmount.inBetween',
                      )}
                    </RadioItem>
                    <RadioItem className={css.item} value={EPolicy.ON_DATE}>
                      {getI18n('general.advancedFilters.commonDate.on')}
                    </RadioItem>
                    <RadioItem className={css.item} value={EPolicy.AFTER_DATE}>
                      {getI18n('general.advancedFilters.commonDate.after')}
                    </RadioItem>
                    <RadioItem className={css.item} value={EPolicy.BEFORE_DATE}>
                      {getI18n('general.advancedFilters.commonDate.before')}
                    </RadioItem>
                  </RadioGroup>
                </Item>{' '}
                <Item
                  noStyle
                  shouldUpdate={(p, c) => {
                    const cT = get(c, policyName);
                    const pT = get(p, policyName);
                    return cT !== pT;
                  }}>
                  {(f) => {
                    const { getFieldValue } = f;
                    const policy = getFieldValue(policyName);
                    return (
                      <PolicyType
                        disabled={disabled}
                        policy={policy}
                        daysName={daysName}
                        noStyle={noStyle}
                        singleDayName={singleDayName}
                        dayRangeName={dayRangeName}
                      />
                    );
                  }}
                </Item>
              </React.Fragment>
            );
          }
          return null;
        }}
      </Item>
    </React.Fragment>
  );
};
export default CommonDate;
const PolicyType = (props) => {
  const {
    policy,
    daysName,
    noStyle,
    singleDayName,
    dayRangeName,
    id,
    disabled,
  } = props;
  const _g = () => {
    if (policy === EPolicy.ANY_TIME) {
      return null;
    }
    if (policy === EPolicy.LAST_SPECIFIC_DAYS) {
      return (
        <Item
          name={daysName}
          noStyle={noStyle}
          rules={[
            {
              required: true,
              message: 'Please fill the input',
              type: 'number',
              min: 1,
            },
          ]}>
          <OriNumberInput
            disabled={disabled}
            //autoFocus
            suffix={'Day(s)'}
            size='large'
            min={0}
          />
        </Item>
      );
    }
    if (
      policy === EPolicy.ON_DATE ||
      policy === EPolicy.AFTER_DATE ||
      policy === EPolicy.BEFORE_DATE
    ) {
      return (
        <Item
          name={singleDayName}
          noStyle={noStyle}
          rules={[
            {
              required: true,
              message: 'Please select a date',
            },
          ]}>
          <SingleDate disabled={disabled} />
        </Item>
      );
    }
    if (policy === EPolicy.IN_BETWEEN) {
      return (
        <Item
          name={dayRangeName}
          noStyle={noStyle}
          rules={[
            {
              required: true,
              message: 'Please select a valid range',
            },
          ]}>
          <DayRange disabled={disabled} />
        </Item>
      );
    }
    return null;
  };

  return (
    <div id={id} style={{ width: '100%' }}>
      {_g()}
    </div>
  );
};

const DayRange = (props) => {
  const { value, onChange, id, disabled } = props;

  const [range, setRange] = React.useState(value || []);
  //console.log('range', range);
  React.useEffect(() => {
    if (value !== range && value) {
      setRange(value);
    }
  }, [value]);

  const handleOnChange = (e) => {
    // const re = e.format('YYYY-MM-DD');
    const re = (e || []).map((i) => {
      if (i) {
        return i.format('YYYY-MM-DD');
      }
      return null;
    });
    setRange(re);

    onChange(re);
  };

  const _value = (range || []).map((i) => {
    if (i) {
      return moment(i);
    }
    return null;
  });

  return (
    <RangePicker
      id={id}
      format={'YYYY-MM-DD'}
      value={_value}
      onChange={handleOnChange}
      className={css.range}
      size='large'
      disabled={disabled}
    />
  );
};

const SingleDate = (props) => {
  const { value, onChange, id, disabled } = props;

  const [date, setDate] = React.useState(value || null);
  React.useEffect(() => {
    if (value !== date && value) {
      setDate(value);
    }
  }, [value]);

  const handleOnChange = (e) => {
    const re = e.format('YYYY-MM-DD');
    setDate(re);

    onChange(re);
  };

  return (
    <OriginalPicker
      disabled={disabled}
      id={id}
      dateFormat={'YYYY-MM-DD'}
      value={date ? moment(date) : null}
      onChange={handleOnChange}
      //autoFocus
      size='large'
    />
  );
};
